import React, { useContext } from 'react';
import { Box, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { PublicUsersProfileContext } from '../../../services/public-users-profile/public-users-profile.context';
import { ProfileContext } from '../../../services/profile/profile.context';
import { AvatarBackground } from './avatar-background';
import { useHistory } from 'react-router-dom';

const useStyle = makeStyles((theme) => ({
  container: {
    width: '100%',
    position: 'relative',
    marginBottom: 20,
  },
  box: {
    borderRadius: '100%',
    width: 150,
    height: 150,
    padding: 4,
    background: '#fff',
    position: 'absolute',
    bottom: -49,
    left: 31,
  },
  avatar: {
    borderRadius: '100%',
    width: '100%',
    height: '100%',
  },
  editProfile: {
    marginLeft: 'auto',
    display: 'block',
    marginTop: 16,
  },
}));

export const UserAvatar = () => {
  const classes = useStyle();
  const history = useHistory();
  const { userInfo } = useContext(PublicUsersProfileContext);
  const { user } = useContext(ProfileContext);

  return (
    <Box>
      <Box className={classes.container}>
        <AvatarBackground />
        <Box className={classes.box}>
          <img
            src={
              userInfo && userInfo.avatar
                ? userInfo.avatar
                : '/icons/default_profile.png'
            }
            alt='public avatar'
            className={classes.avatar}
          />
        </Box>
      </Box>

      {userInfo && user && userInfo.username === user.username && (
        <Button
          className={classes.editProfile}
          variant='outlined'
          color='primary'
          onClick={() => history.push('/account/profile')}
        >
          edit profile
        </Button>
      )}
    </Box>
  );
};
